// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"_1iOdzp6","backdropVisible":"iVBGLVO","sidebar":"_38QPajy","menuItems":"_18YVm-F","buttonClose":"_1YTo1mY","sidebarOpen":"_3CvILhV"};